module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3ODkgMTAzIiB3aWR0aD0iNzg5IiBoZWlnaHQ9IjEwMyI+PHBvbHlsaW5lIHBvaW50cz0iNzUwIDAgNzg5IDEwMyAwIDEwMyAwIDAiIGZpbGw9InJnYmEoNDYsMjAsNjYsMC43NSkiIC8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/hero/shade.svg
// module id = ./src/styles/marketing/hero/shade.svg
// module chunks = 21